import React, { useState } from 'react'
import { Dialog, DialogContent, TextField, Typography } from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import { currentDate } from '@auteco/constants'
import { useStyles } from './styles'

const DialogAgreement = ({ open, onClose, sendDetailedPlan }) => {
    const [finalAmount, setFinalAmount] = useState('')

    const classes = useStyles()
    const updatePlan = async () => {
        sendDetailedPlan({ valoracion_final: Number(finalAmount), finalizado: 1, fecha_cierre: currentDate })
        onClose()
    }
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <Typography>Esta por cerrar un acuerdo. Debe ingresar el beneficio final</Typography>
                <div className={classes.amountCointainer}>
                    <Typography>Beneficio final:</Typography>
                    <TextField
                        className={classes.textField}
                        onChange={(e) => setFinalAmount(e.target.value)}
                    />
                </div>
                <div className={classes.buttonsContainer}>
                    <Button
                        style={{ width: '80px' }}
                        onClick={onClose}
                    >
                        Cerrar
                    </Button>
                    <Button
                        style={{ width: '80px' }}
                        color='facebook'
                        disabled={finalAmount === ''}
                        onClick={updatePlan}
                    >
                        Ok
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export { DialogAgreement }